export const VIEW_TYPE_TABLE = 'table'
export const VIEW_TYPE_CHART = 'chart'
